<router-outlet></router-outlet>
<div class="loader" *ngIf="isLoading | async">
  <app-loading></app-loading>
</div>
